/**
 * @generated SignedSource<<2ed55b7bd4634597b4be2cec370259fd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalSortEnum = "CREATION_DATE_ASC" | "CREATION_DATE_DESC" | "HIERARCHY_ASC" | "HIERARCHY_DESC" | "HIERARCHY_LEVEL_ASC" | "HIERARCHY_LEVEL_DESC" | "ID_ASC" | "ID_DESC" | "LATEST_UPDATE_DATE_ASC" | "LATEST_UPDATE_DATE_DESC" | "NAME_ASC" | "NAME_DESC" | "PHASE_ID_ASC" | "PHASE_ID_DESC" | "PROJECT_COUNT_ASC" | "PROJECT_COUNT_DESC" | "SCORE_ASC" | "SCORE_DESC" | "START_DATE_ASC" | "START_DATE_DESC" | "TARGET_DATE_ASC" | "TARGET_DATE_DESC" | "WATCHER_COUNT_ASC" | "WATCHER_COUNT_DESC" | "WATCHING_ASC" | "WATCHING_DESC";
export type DirectoryViewGoalQuery$variables = {
  after?: string | null;
  containerId?: string | null;
  directoryViewUuid?: string | null;
  first?: number | null;
  includeFollowerCount: boolean;
  includeFollowing: boolean;
  includeLastUpdated: boolean;
  includeOwner: boolean;
  includeRelatedProjects: boolean;
  includeStatus: boolean;
  includeTags: boolean;
  includeTargetDate: boolean;
  includeTeam: boolean;
  includedCustomFieldUuids?: ReadonlyArray<string> | null;
  showDecisions: boolean;
  showLatestUpdate: boolean;
  showLearnings: boolean;
  showRisks: boolean;
  skipTableTql: boolean;
  sorts?: ReadonlyArray<GoalSortEnum | null> | null;
  tql?: string | null;
  workspaceUuid?: string | null;
};
export type DirectoryViewGoalQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryTableViewGoal" | "GoalTimeline">;
};
export type DirectoryViewGoalQuery = {
  response: DirectoryViewGoalQuery$data;
  variables: DirectoryViewGoalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "directoryViewUuid"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeFollowerCount"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeFollowing"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeLastUpdated"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOwner"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRelatedProjects"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeStatus"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTags"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTargetDate"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTeam"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includedCustomFieldUuids"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showDecisions"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showLatestUpdate"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showLearnings"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showRisks"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipTableTql"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sorts"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tql"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v22 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v23 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v24 = {
  "kind": "Variable",
  "name": "directoryViewUuid",
  "variableName": "directoryViewUuid"
},
v25 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v26 = {
  "kind": "Variable",
  "name": "includedCustomFieldUuids",
  "variableName": "includedCustomFieldUuids"
},
v27 = {
  "kind": "Variable",
  "name": "sorts",
  "variableName": "sorts"
},
v28 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v29 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "tql"
},
v30 = [
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v29/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/)
],
v31 = {
  "kind": "ScalarField",
  "name": "count"
},
v32 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v33 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v34 = {
  "kind": "ScalarField",
  "name": "value"
},
v35 = {
  "kind": "ScalarField",
  "name": "label"
},
v36 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v37 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v36/*: any*/)
},
v38 = {
  "kind": "ScalarField",
  "name": "score"
},
v39 = {
  "kind": "ScalarField",
  "name": "id"
},
v40 = {
  "kind": "ScalarField",
  "name": "key"
},
v41 = {
  "kind": "ScalarField",
  "name": "name"
},
v42 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v43 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v44 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v45 = [
  (v41/*: any*/)
],
v46 = {
  "kind": "ScalarField",
  "name": "archived"
},
v47 = [
  (v39/*: any*/)
],
v48 = {
  "concreteType": "Goal",
  "kind": "LinkedField",
  "name": "parentGoal",
  "plural": false,
  "selections": (v47/*: any*/)
},
v49 = {
  "kind": "InlineFragment",
  "selections": (v47/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v50 = [
  {
    "kind": "ScalarField",
    "name": "canSetMultipleValues"
  }
],
v51 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v52 = {
  "kind": "ScalarField",
  "name": "picture"
},
v53 = {
  "kind": "ScalarField",
  "name": "watcherCount"
},
v54 = {
  "kind": "ScalarField",
  "name": "type"
},
v55 = [
  (v54/*: any*/),
  {
    "kind": "ScalarField",
    "name": "percentage"
  }
],
v56 = [
  (v34/*: any*/),
  (v39/*: any*/)
],
v57 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v58 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v59 = {
  "concreteType": "Metric",
  "kind": "LinkedField",
  "name": "metric",
  "plural": false,
  "selections": [
    (v39/*: any*/),
    (v41/*: any*/),
    (v54/*: any*/),
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    (v46/*: any*/)
  ]
},
v60 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v61 = {
  "kind": "ScalarField",
  "name": "watching"
},
v62 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v63 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v35/*: any*/),
  (v37/*: any*/),
  {
    "alias": "tooltip",
    "args": (v62/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v62/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v36/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v64 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v65 = {
  "alias": "goalStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v66 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v64/*: any*/),
    (v37/*: any*/),
    (v34/*: any*/),
    (v38/*: any*/)
  ]
},
v67 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v68 = {
  "kind": "ScalarField",
  "name": "description"
},
v69 = [
  (v31/*: any*/)
],
v70 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  }
],
v71 = {
  "kind": "ScalarField",
  "name": "summary"
},
v72 = {
  "kind": "ScalarField",
  "name": "ari"
},
v73 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v39/*: any*/)
  ]
},
v74 = [
  (v35/*: any*/)
],
v75 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v41/*: any*/),
      (v52/*: any*/),
      (v51/*: any*/)
    ]
  },
  (v67/*: any*/),
  (v39/*: any*/)
],
v76 = {
  "kind": "InlineFragment",
  "selections": [
    (v71/*: any*/),
    (v68/*: any*/),
    (v72/*: any*/),
    {
      "concreteType": "Project",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v39/*: any*/),
        (v40/*: any*/),
        (v41/*: any*/),
        (v32/*: any*/),
        (v72/*: any*/),
        (v73/*: any*/),
        {
          "concreteType": "ProjectState",
          "kind": "LinkedField",
          "name": "state",
          "plural": false,
          "selections": (v74/*: any*/)
        }
      ]
    },
    {
      "concreteType": "Goal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        (v39/*: any*/),
        (v40/*: any*/),
        (v41/*: any*/),
        (v32/*: any*/),
        (v72/*: any*/),
        (v73/*: any*/),
        {
          "concreteType": "GoalState",
          "kind": "LinkedField",
          "name": "state",
          "plural": false,
          "selections": (v74/*: any*/)
        }
      ]
    },
    {
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": (v75/*: any*/)
    },
    (v33/*: any*/),
    {
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "lastEditedBy",
      "plural": false,
      "selections": (v75/*: any*/)
    },
    {
      "kind": "ScalarField",
      "name": "lastEditedDate"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isRecentlyAdded"
        }
      ]
    }
  ],
  "type": "Highlight",
  "abstractKey": "__isHighlight"
},
v77 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v78 = [
  (v39/*: any*/),
  (v32/*: any*/),
  (v42/*: any*/),
  (v76/*: any*/)
],
v79 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v80 = {
  "kind": "ScalarField",
  "name": "editDate"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DirectoryViewGoalQuery",
    "selections": [
      {
        "args": [
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "kind": "Variable",
            "name": "includeFollowerCount",
            "variableName": "includeFollowerCount"
          },
          {
            "kind": "Variable",
            "name": "includeFollowing",
            "variableName": "includeFollowing"
          },
          {
            "kind": "Variable",
            "name": "includeLastUpdated",
            "variableName": "includeLastUpdated"
          },
          {
            "kind": "Variable",
            "name": "includeOwner",
            "variableName": "includeOwner"
          },
          {
            "kind": "Variable",
            "name": "includeRelatedProjects",
            "variableName": "includeRelatedProjects"
          },
          {
            "kind": "Variable",
            "name": "includeStatus",
            "variableName": "includeStatus"
          },
          {
            "kind": "Variable",
            "name": "includeTags",
            "variableName": "includeTags"
          },
          {
            "kind": "Variable",
            "name": "includeTargetDate",
            "variableName": "includeTargetDate"
          },
          {
            "kind": "Variable",
            "name": "includeTeam",
            "variableName": "includeTeam"
          },
          (v26/*: any*/),
          {
            "kind": "Variable",
            "name": "showDecisions",
            "variableName": "showDecisions"
          },
          {
            "kind": "Variable",
            "name": "showLatestUpdate",
            "variableName": "showLatestUpdate"
          },
          {
            "kind": "Variable",
            "name": "showLearnings",
            "variableName": "showLearnings"
          },
          {
            "kind": "Variable",
            "name": "showRisks",
            "variableName": "showRisks"
          },
          {
            "kind": "Variable",
            "name": "skipTableTql",
            "variableName": "skipTableTql"
          },
          (v27/*: any*/),
          {
            "kind": "Variable",
            "name": "tql",
            "variableName": "tql"
          },
          (v28/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "DirectoryTableViewGoal"
      },
      {
        "args": [
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v29/*: any*/),
          {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sorts"
          },
          (v28/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalTimeline"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v20/*: any*/),
      (v21/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v19/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v10/*: any*/),
      (v13/*: any*/),
      (v18/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Operation",
    "name": "DirectoryViewGoalQuery",
    "selections": [
      {
        "alias": "goalTimeline",
        "args": (v30/*: any*/),
        "concreteType": "GoalConnection",
        "kind": "LinkedField",
        "name": "goalTql",
        "plural": false,
        "selections": [
          (v31/*: any*/),
          {
            "concreteType": "GoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v32/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "startDate"
                  },
                  (v33/*: any*/),
                  {
                    "concreteType": "GoalState",
                    "kind": "LinkedField",
                    "name": "state",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetDateConfidence"
                  },
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/)
                ]
              },
              (v43/*: any*/)
            ]
          },
          (v44/*: any*/)
        ]
      },
      {
        "alias": "goalTimeline",
        "args": (v30/*: any*/),
        "filters": [
          "workspaceUuid",
          "containerId",
          "q",
          "directoryViewUuid",
          "sorts"
        ],
        "handle": "connection",
        "key": "GoalTimeline__goalTimeline",
        "kind": "LinkedHandle",
        "name": "goalTql"
      },
      {
        "condition": "skipTableTql",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v30/*: any*/),
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalTqlFullHierarchy",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v39/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "hasSubgoalMatches"
                      },
                      {
                        "concreteType": "ManagerDataResponse",
                        "kind": "LinkedField",
                        "name": "managerData",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "ManagerData",
                            "kind": "LinkedField",
                            "name": "managers",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "UserPII",
                                "kind": "LinkedField",
                                "name": "managerProfile",
                                "plural": false,
                                "selections": (v45/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "name": "directReports"
                              }
                            ]
                          }
                        ]
                      },
                      (v32/*: any*/),
                      (v40/*: any*/),
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          (v34/*: any*/)
                        ]
                      },
                      (v41/*: any*/),
                      (v46/*: any*/),
                      (v48/*: any*/),
                      {
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "subGoals",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v46/*: any*/),
                                  (v39/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v31/*: any*/)
                        ]
                      },
                      {
                        "args": [
                          (v26/*: any*/)
                        ],
                        "concreteType": "CustomFieldConnection",
                        "kind": "LinkedField",
                        "name": "customFields",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CustomFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v42/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "definition",
                                        "plural": false,
                                        "selections": [
                                          (v42/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v32/*: any*/)
                                            ],
                                            "type": "CustomFieldDefinitionNode",
                                            "abstractKey": "__isCustomFieldDefinitionNode"
                                          },
                                          (v49/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "CustomFieldNode",
                                    "abstractKey": "__isCustomFieldNode"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldNumberSavedValueNode",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": "numberValue",
                                            "kind": "ScalarField",
                                            "name": "value"
                                          },
                                          (v39/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "NumberCustomField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "definition",
                                        "plural": false,
                                        "selections": [
                                          (v42/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v50/*: any*/),
                                            "type": "TextSelectCustomFieldDefinition"
                                          },
                                          (v49/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "CustomFieldTextSavedValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "CustomFieldTextSavedValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "CustomFieldTextSavedValueNode",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v39/*: any*/),
                                                  (v34/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "TextSelectCustomField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "definition",
                                        "plural": false,
                                        "selections": [
                                          (v42/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v50/*: any*/),
                                            "type": "UserCustomFieldDefinition"
                                          },
                                          (v49/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "UserConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "UserEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "User",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "UserPII",
                                                    "kind": "LinkedField",
                                                    "name": "pii",
                                                    "plural": false,
                                                    "selections": [
                                                      (v51/*: any*/),
                                                      (v41/*: any*/),
                                                      (v52/*: any*/)
                                                    ]
                                                  },
                                                  (v39/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "UserCustomField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextSavedValueNode",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": "textValue",
                                            "kind": "ScalarField",
                                            "name": "value"
                                          },
                                          (v39/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "TextCustomField"
                                  },
                                  (v49/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v53/*: any*/),
                      {
                        "concreteType": "TagConnection",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TagEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Tag",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v39/*: any*/),
                                  (v41/*: any*/),
                                  (v53/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "progress",
                        "plural": false,
                        "selections": (v55/*: any*/)
                      },
                      {
                        "concreteType": "MetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v39/*: any*/),
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "snapshotValue",
                                    "plural": false,
                                    "selections": (v56/*: any*/)
                                  },
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v42/*: any*/),
                      {
                        "condition": "includeLastUpdated",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v60/*: any*/)
                        ]
                      },
                      {
                        "condition": "includeFollowing",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v61/*: any*/)
                        ]
                      },
                      {
                        "condition": "includeTargetDate",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "TargetDate",
                            "kind": "LinkedField",
                            "name": "dueDate",
                            "plural": false,
                            "selections": (v63/*: any*/)
                          }
                        ]
                      },
                      {
                        "condition": "includeStatus",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": [
                              (v64/*: any*/),
                              (v37/*: any*/),
                              (v65/*: any*/),
                              (v66/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeOwner",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v67/*: any*/),
                              {
                                "concreteType": "UserPII",
                                "kind": "LinkedField",
                                "name": "pii",
                                "plural": false,
                                "selections": [
                                  (v52/*: any*/),
                                  (v51/*: any*/)
                                ]
                              },
                              (v39/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeRelatedProjects",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "ProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              {
                                "concreteType": "ProjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Project",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v39/*: any*/),
                                      (v40/*: any*/),
                                      (v41/*: any*/),
                                      (v32/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "private"
                                      },
                                      {
                                        "concreteType": "IconURIs",
                                        "kind": "LinkedField",
                                        "name": "iconUrl",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "ThemeURIs",
                                            "kind": "LinkedField",
                                            "name": "square",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "light"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "dark"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeTeam",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "GoalTeamConnection",
                            "kind": "LinkedField",
                            "name": "teamsV2",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GoalTeamEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Team",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "avatarUrl"
                                      },
                                      (v41/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "teamId"
                                      },
                                      (v39/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v31/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeTags",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "TagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TagEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v68/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "projectUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "goalUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "helpPointerUsageCount"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v31/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeFollowerCount",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "UserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": (v69/*: any*/)
                          }
                        ]
                      },
                      {
                        "condition": "showLearnings",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "learningsCount"
                          },
                          {
                            "args": (v70/*: any*/),
                            "concreteType": "LearningConnection",
                            "kind": "LinkedField",
                            "name": "learnings",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              {
                                "concreteType": "LearningEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Learning",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v39/*: any*/),
                                      (v32/*: any*/),
                                      (v54/*: any*/),
                                      (v42/*: any*/),
                                      (v76/*: any*/)
                                    ]
                                  },
                                  (v43/*: any*/)
                                ]
                              },
                              (v44/*: any*/),
                              (v77/*: any*/)
                            ],
                            "storageKey": "learnings(first:200)"
                          },
                          {
                            "args": (v70/*: any*/),
                            "handle": "connection",
                            "key": "HighlightsList__learnings",
                            "kind": "LinkedHandle",
                            "name": "learnings"
                          }
                        ]
                      },
                      {
                        "condition": "showRisks",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "risksCount"
                          },
                          {
                            "args": (v70/*: any*/),
                            "concreteType": "RiskConnection",
                            "kind": "LinkedField",
                            "name": "risks",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              {
                                "concreteType": "RiskEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Risk",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v78/*: any*/)
                                  },
                                  (v43/*: any*/)
                                ]
                              },
                              (v44/*: any*/),
                              (v77/*: any*/)
                            ],
                            "storageKey": "risks(first:200)"
                          },
                          {
                            "args": (v70/*: any*/),
                            "handle": "connection",
                            "key": "HighlightsList__risks",
                            "kind": "LinkedHandle",
                            "name": "risks"
                          }
                        ]
                      },
                      {
                        "condition": "showDecisions",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "decisionsCount"
                          },
                          {
                            "args": (v70/*: any*/),
                            "concreteType": "DecisionConnection",
                            "kind": "LinkedField",
                            "name": "decisions",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              {
                                "concreteType": "DecisionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Decision",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v78/*: any*/)
                                  },
                                  (v43/*: any*/)
                                ]
                              },
                              (v44/*: any*/),
                              (v77/*: any*/)
                            ],
                            "storageKey": "decisions(first:200)"
                          },
                          {
                            "args": (v70/*: any*/),
                            "handle": "connection",
                            "key": "HighlightsList__decisions",
                            "kind": "LinkedHandle",
                            "name": "decisions"
                          }
                        ]
                      },
                      {
                        "condition": "showLatestUpdate",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              (v32/*: any*/),
                              {
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                  (v67/*: any*/),
                                  (v39/*: any*/),
                                  {
                                    "concreteType": "UserPII",
                                    "kind": "LinkedField",
                                    "name": "pii",
                                    "plural": false,
                                    "selections": [
                                      (v52/*: any*/),
                                      (v51/*: any*/),
                                      (v41/*: any*/),
                                      (v79/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "missedUpdate"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "updateType"
                              },
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v72/*: any*/),
                                  (v32/*: any*/),
                                  (v73/*: any*/),
                                  (v39/*: any*/),
                                  (v61/*: any*/),
                                  (v48/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  {
                                    "concreteType": "GoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "latestUserUpdate",
                                    "plural": false,
                                    "selections": [
                                      (v39/*: any*/),
                                      (v33/*: any*/)
                                    ]
                                  },
                                  (v60/*: any*/),
                                  {
                                    "concreteType": "GoalConnection",
                                    "kind": "LinkedField",
                                    "name": "subGoals",
                                    "plural": false,
                                    "selections": (v69/*: any*/)
                                  },
                                  {
                                    "concreteType": "MetricTargetConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargets",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "MetricTargetEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "MetricTarget",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v57/*: any*/),
                                              (v58/*: any*/),
                                              (v39/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "GoalState",
                                "kind": "LinkedField",
                                "name": "newState",
                                "plural": false,
                                "selections": [
                                  (v34/*: any*/),
                                  (v38/*: any*/),
                                  (v65/*: any*/),
                                  (v64/*: any*/),
                                  (v37/*: any*/),
                                  (v66/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "UserViews",
                                "kind": "LinkedField",
                                "name": "views",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "viewCount"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "objectType"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "objectId"
                                  },
                                  (v39/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "viewed"
                                  }
                                ]
                              },
                              (v33/*: any*/),
                              {
                                "concreteType": "GoalMetricUpdateConnection",
                                "kind": "LinkedField",
                                "name": "metricUpdate",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "GoalMetricUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "GoalMetricUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "newStartValue"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "newTargetValue"
                                          },
                                          {
                                            "concreteType": "MetricValue",
                                            "kind": "LinkedField",
                                            "name": "newValue",
                                            "plural": false,
                                            "selections": (v56/*: any*/)
                                          },
                                          (v59/*: any*/),
                                          {
                                            "concreteType": "MetricValue",
                                            "kind": "LinkedField",
                                            "name": "oldValue",
                                            "plural": false,
                                            "selections": (v56/*: any*/)
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "GoalProgress",
                                "kind": "LinkedField",
                                "name": "newProgress",
                                "plural": false,
                                "selections": (v55/*: any*/)
                              },
                              (v72/*: any*/),
                              {
                                "concreteType": "CommentConnection",
                                "kind": "LinkedField",
                                "name": "comments",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v39/*: any*/),
                                          (v80/*: any*/),
                                          (v72/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "commentText"
                                          },
                                          (v33/*: any*/),
                                          {
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "creator",
                                            "plural": false,
                                            "selections": [
                                              (v67/*: any*/),
                                              {
                                                "concreteType": "UserPII",
                                                "kind": "LinkedField",
                                                "name": "pii",
                                                "plural": false,
                                                "selections": [
                                                  (v52/*: any*/),
                                                  (v41/*: any*/),
                                                  (v79/*: any*/),
                                                  (v51/*: any*/)
                                                ]
                                              },
                                              (v39/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v77/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "lastEditedBy",
                                "plural": false,
                                "selections": [
                                  (v67/*: any*/),
                                  {
                                    "concreteType": "UserPII",
                                    "kind": "LinkedField",
                                    "name": "pii",
                                    "plural": false,
                                    "selections": (v45/*: any*/)
                                  },
                                  (v39/*: any*/)
                                ]
                              },
                              (v80/*: any*/),
                              {
                                "concreteType": "TargetDate",
                                "kind": "LinkedField",
                                "name": "newDueDate",
                                "plural": false,
                                "selections": (v63/*: any*/)
                              },
                              (v71/*: any*/),
                              {
                                "concreteType": "UpdateNote",
                                "kind": "LinkedField",
                                "name": "notes",
                                "plural": true,
                                "selections": [
                                  (v46/*: any*/),
                                  (v32/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "title"
                                  },
                                  (v71/*: any*/),
                                  (v39/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TargetDate",
                                "kind": "LinkedField",
                                "name": "oldDueDate",
                                "plural": false,
                                "selections": (v63/*: any*/)
                              },
                              {
                                "concreteType": "GoalState",
                                "kind": "LinkedField",
                                "name": "oldState",
                                "plural": false,
                                "selections": [
                                  (v64/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "Project",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": [
                                          (v40/*: any*/),
                                          (v39/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "ProjectUpdate"
                                  }
                                ],
                                "type": "Update",
                                "abstractKey": "__isUpdate"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v43/*: any*/)
                ]
              },
              (v44/*: any*/),
              (v77/*: any*/)
            ]
          },
          {
            "args": (v30/*: any*/),
            "filters": [
              "q",
              "workspaceUuid",
              "containerId",
              "sorts",
              "directoryViewUuid"
            ],
            "handle": "connection",
            "key": "DirectoryTable__goalTqlFullHierarchy",
            "kind": "LinkedHandle",
            "name": "goalTqlFullHierarchy"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "d385f6916d4d81e741f7d18a7f04817f",
    "id": null,
    "metadata": {},
    "name": "DirectoryViewGoalQuery",
    "operationKind": "query",
    "text": "query DirectoryViewGoalQuery(\n  $tql: String\n  $workspaceUuid: UUID\n  $containerId: String\n  $after: String\n  $first: Int\n  $sorts: [GoalSortEnum]\n  $directoryViewUuid: UUID\n  $includeFollowerCount: Boolean!\n  $includeFollowing: Boolean!\n  $includeLastUpdated: Boolean!\n  $includeOwner: Boolean!\n  $includeRelatedProjects: Boolean!\n  $includeStatus: Boolean!\n  $includeTargetDate: Boolean!\n  $includeTeam: Boolean!\n  $includeTags: Boolean!\n  $includedCustomFieldUuids: [UUID!]\n  $skipTableTql: Boolean!\n  $showLearnings: Boolean!\n  $showRisks: Boolean!\n  $showDecisions: Boolean!\n  $showLatestUpdate: Boolean!\n) {\n  ...DirectoryTableViewGoal_3jtuHf\n  ...GoalTimeline_16XmRm\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment CustomFieldCell on CustomFieldConnection {\n  edges {\n    node {\n      __typename\n      ... on CustomFieldNode {\n        __isCustomFieldNode: __typename\n        definition {\n          __typename\n          ... on CustomFieldDefinitionNode {\n            __isCustomFieldDefinitionNode: __typename\n            uuid\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n      ...NumberFieldColumn\n      ...TextSelectFieldColumn\n      ...UserFieldColumn\n      ...TextFieldColumn\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment DirectoryRow_4dmSpH on Goal {\n  id\n  hasSubgoalMatches\n  latestUpdateDate @include(if: $includeLastUpdated)\n  ...GoalNameColumn\n  ...GoalFollowButton @include(if: $includeFollowing)\n  ...GoalActions\n  dueDate @include(if: $includeTargetDate) {\n    ...TargetDate\n  }\n  state @include(if: $includeStatus) {\n    ...GoalState\n  }\n  owner @include(if: $includeOwner) {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  projects @include(if: $includeRelatedProjects) {\n    ...RelatedGoalProjects\n  }\n  teamsV2 @include(if: $includeTeam) {\n    ...TeamOfGoal\n  }\n  tags @include(if: $includeTags) {\n    ...TagColumn\n  }\n  ...FollowerCount_goal @include(if: $includeFollowerCount)\n  customFields(includedCustomFieldUuids: $includedCustomFieldUuids) {\n    ...CustomFieldCell\n  }\n  learningsCount @include(if: $showLearnings)\n  risksCount @include(if: $showRisks)\n  decisionsCount @include(if: $showDecisions)\n  ...HighlightsList_48wrXp\n  latestUserUpdate @include(if: $showLatestUpdate) {\n    ...GoalUpdateCard\n    id\n  }\n  ...MetricColumn\n}\n\nfragment DirectoryTableViewGoal_3jtuHf on Query {\n  goalTqlFullHierarchy(first: $first, after: $after, q: $tql, workspaceUuid: $workspaceUuid, containerId: $containerId, sorts: $sorts, directoryViewUuid: $directoryViewUuid) @skip(if: $skipTableTql) {\n    count\n    edges {\n      node {\n        id\n        ...RootDirectoryRow_4dmSpH\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment FollowerCount_goal on Goal {\n  ...GoalFollowersButton\n}\n\nfragment GoalActions on Goal {\n  id\n  name\n  archived\n  parentGoal {\n    id\n  }\n  subGoals {\n    edges {\n      node {\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment GoalBar on Goal {\n  startDate\n  creationDate\n  state {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n  targetDate\n  targetDateConfidence\n  ...GoalName\n  ...utilsGetGoalTargetEndDate\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n}\n\nfragment GoalFollowersButton on Goal {\n  key\n  watchers {\n    count\n  }\n}\n\nfragment GoalIcon on Goal {\n  state {\n    score\n    value\n  }\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...GoalIcon\n  name\n}\n\nfragment GoalNameColumn on Goal {\n  id\n  managerData {\n    managers {\n      managerProfile {\n        name\n      }\n      directReports\n    }\n  }\n  ...GoalName\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  goalStateValue: value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newState {\n    ...GoalState\n  }\n  oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalTimeline_16XmRm on Query {\n  goalTimeline: goalTql(first: $first, after: $after, workspaceUuid: $workspaceUuid, containerId: $containerId, q: $tql, directoryViewUuid: $directoryViewUuid, sorts: $sorts) {\n    count\n    edges {\n      node {\n        uuid\n        startDate\n        creationDate\n        ...GoalBar\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment GoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    id\n  }\n  views {\n    ...ViewsTracker\n    id\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  newState {\n    value\n    score\n  }\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  goal {\n    id\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  views {\n    ...Views\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  views {\n    ...Views\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  creationDate\n  editDate\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newState {\n    goalStateValue: value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment HighlightsList_48wrXp on Goal {\n  learnings(first: 200) @include(if: $showLearnings) {\n    count\n    edges {\n      node {\n        id\n        uuid\n        type\n        ... on Highlight {\n          __isHighlight: __typename\n          ...Learning_data\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  risks(first: 200) @include(if: $showRisks) {\n    count\n    edges {\n      node {\n        id\n        uuid\n        ... on Highlight {\n          __isHighlight: __typename\n          ...Learning_data\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  decisions(first: 200) @include(if: $showDecisions) {\n    count\n    edges {\n      node {\n        id\n        uuid\n        ... on Highlight {\n          __isHighlight: __typename\n          ...Learning_data\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  watcherCount\n  tags {\n    ...LearningTags_data\n  }\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningTags_data on TagConnection {\n  edges {\n    node {\n      id\n      name\n      watcherCount\n    }\n  }\n}\n\nfragment Learning_data on Highlight {\n  __isHighlight: __typename\n  __typename\n  id\n  summary\n  description\n  uuid\n  ari\n  project {\n    id\n    key\n    name\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  goal {\n    id\n    key\n    name\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  ...LearningModifierSignatures_data\n}\n\nfragment MetricColumn on Goal {\n  id\n  ...metricTargetPopup\n  ...progressBarMetricTarget\n  ...hasMetric\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment NumberFieldColumn on NumberCustomField {\n  value {\n    numberValue: value\n    id\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment RelatedGoalProjects on ProjectConnection {\n  count\n  edges {\n    node {\n      ...ProjectName_data\n      id\n    }\n  }\n}\n\nfragment RootDirectoryRow_4dmSpH on Goal {\n  id\n  ...DirectoryRow_4dmSpH\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment TagColumn on TagConnection {\n  edges {\n    node {\n      ...Tag\n      id\n    }\n  }\n  count\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment TeamOfGoal on GoalTeamConnection {\n  edges {\n    node {\n      avatarUrl\n      name\n      teamId\n      id\n    }\n  }\n  count\n}\n\nfragment TextFieldColumn on TextCustomField {\n  value {\n    textValue: value\n    id\n  }\n}\n\nfragment TextSelectFieldColumn on TextSelectCustomField {\n  definition {\n    __typename\n    ... on TextSelectCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    count\n    edges {\n      node {\n        id\n        value\n      }\n    }\n  }\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserFieldColumn on UserCustomField {\n  definition {\n    __typename\n    ... on UserCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    count\n    edges {\n      node {\n        pii {\n          accountId\n          name\n          picture\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment ViewersModalFragment on UserViews {\n  viewCount\n  objectType\n  objectId\n}\n\nfragment Views on UserViews {\n  viewCount\n  ...ViewsTooltipContent\n  ...ViewersModalFragment\n}\n\nfragment ViewsTooltipContent on UserViews {\n  viewCount\n  objectType\n  objectId\n}\n\nfragment ViewsTracker on UserViews {\n  viewed\n}\n\nfragment hasMetric on Goal {\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment metricTargetPopup on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment utilsGetGoalTargetEndDate on Goal {\n  startDate\n  creationDate\n  targetDate\n  targetDateConfidence\n}\n"
  }
};
})();

(node as any).hash = "c027e63c4e21c11bca43229667adc726";

export default node;
